import { KuposButton, KuposSuccessFailure } from '../common';

import Lottie from 'lottie-react';
import React from 'react';
import cross from '../../images/anims/xmark_anim.json';
import i18next from 'i18next';
import tick from '../../images/anims/checkmark_anim.json';
import { useEffect } from 'react';
import { useState } from 'react';
import { withTranslation } from 'react-i18next';

const ChangeTicketResponse = ({ t, history }) => {
  const [response, setResponse] = useState('');

  useEffect(() => {
    if (
      !sessionStorage.getItem('changeTicketDetailsResponse') &&
      !sessionStorage.getItem('confirmTicketDataResponse')
    ) {
      history.push('/');
    } else {
      let response = JSON.parse(sessionStorage.getItem('changeTicketDetailsResponse'));
      if (window.location.href.indexOf('confirm-ticket') > -1) {
        response = JSON.parse(sessionStorage.getItem('confirmTicketDataResponse'));
      }

      setResponse(response);
      // sessionStorage.removeItem('changeTicketDetailsResponse');
    }
    // return () => sessionStorage.removeItem('changeTicketDetailsResponse');
  }, []);

  return (
    <div className="content-container">
      {!(response && response.success) ? (
        <KuposSuccessFailure
          success={false}
          subtitle={t('CHANGE_TICKET.TICKET_ERROR')}
          // infoText={t('CANCEL_TICKET.SENT_EMAIL')}
          t={t}
        />
      ) : (
        <React.Fragment>
          <div
            className="d-flex flex-column align-items-center anim-container margin-T50"
            style={{ width: 'auto' }}
          >
            <Lottie animationData={response && response.success ? tick : cross} loop={false} />
            <div className="mt-y-3 cancel-ticket-done">
              <span className="bold-text font15">
                {i18next.language == 'es' ? '¡Listo!' : 'All set!'}
              </span>
            </div>
            <div className="cancel-ticket-done cancel-ticket-done-desc font12 d-flex flex-column">
              <span style={{ textAlign: 'center' }}>{response.result.resultado.mensaje}</span>
              {/* <span style={{ textAlign: 'center' }}>{t('CHANGE_TICKET.SUCCESS_MESSAGE_1')}</span> */}
              {/* <span style={{ textAlign: 'center' }}>{t('CHANGE_TICKET.SUCCESS_MESSAGE_2')}</span> */}
            </div>
          </div>
          <div className="change-ticket-success-page margin-T20">
            <div className="pullman-section-primary-row">
              <div className="pullman-section-primary-row-main-heading black-text ">
                <span>{t('CHANGE_TICKET.SUCCESS_MESSAGE_2')}</span>
              </div>
              <div className="pullman-section-primary-row-underline margin-B35"></div>
              <div className="change-ticket-success-page-details ">
                <div className="change-ticket-success-page-details-box ">
                  <div className="change-ticket-success-page-details-label black-text font12">
                    {t('CHANGE_TICKET.PASSENGER')}
                  </div>
                  <div className="change-ticket-success-page-details-value font9">
                    {response && response.result && response.result.voucher.boleto}
                  </div>
                </div>

                <div className="change-ticket-success-page-details-box">
                  <div className="change-ticket-success-page-details-label black-text font12">
                    {t('CHANGE_TICKET.ORIGIN')}
                  </div>
                  <div className="change-ticket-success-page-details-value font9">
                    {response && response.origin_name}
                  </div>
                </div>

                <div className="change-ticket-success-page-details-box">
                  <div className="change-ticket-success-page-details-label black-text font12">
                    {t('CHANGE_TICKET.DESTINATION')}
                  </div>
                  <div className="change-ticket-success-page-details-value font9">
                    {response && response.destination_name}
                  </div>
                </div>

                <div className="change-ticket-success-page-details-box">
                  <div className="change-ticket-success-page-details-label black-text font12">
                    {t('CHANGE_TICKET.COST')}
                  </div>
                  <div className="change-ticket-success-page-details-value font9">
                    ${response && response.result && response.result.voucher.total}
                  </div>
                </div>
                <div className="change-ticket-success-page-details-box">
                  <div className="change-ticket-success-page-details-label black-text font12">
                    {t('CHANGE_TICKET.CLASS')}
                  </div>
                  <div className="change-ticket-success-page-details-value font9">
                    {response && response.result && response.result.voucher.clase}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="change-ticket-success-page-buttons">
            <KuposButton
              onClick={() => {
                const linkSource = `data:application/pdf;base64,${response.result.archivo.archivo}`;
                const downloadLink = document.createElement('a');
                const fileName = response.result.archivo.nombre;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
              }}
              className=" font12"
            >
              {i18next.language == 'es' ? 'Descarga tu pasaje' : 'Download your proof'}
            </KuposButton>
            <KuposButton
              className=" font12"
              onClick={() => history.push(`/${i18next.language}/pages/contact`)}
            >
              {i18next.language == 'es' ? 'Contáctanos' : 'Contact us'}
            </KuposButton>
            <KuposButton className=" font12" onClick={() => history.push('/')}>
              {i18next.language == 'es' ? 'Volver al inicio' : 'Back to top'}
            </KuposButton>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default withTranslation('common')(ChangeTicketResponse);



// WEBPACK FOOTER //
// ./src/features/pages/ChangeTicketResponse.js